import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import FFFooter from '@ff/ui/Footer';
import FFFooter2 from '@ff/ui/Footer2';
import FFFooter3 from '@ff/ui/Footer3';
import { IS_APP } from 'shared/lib/pathUtils';

const OldFooterWrapper = styled(Box)({
  '& button': {
    backgroundColor: 'black',
    color: 'white',
    borderColor: 'white',

    ':hover': {
      backgroundColor: 'white',
      color: 'black',
      borderColor: 'black'
    },
    ':active': {
      backgroundColor: 'white',
      color: 'black',
      borderColor: 'black'
    }
  }
});

export default function Footer(props) {
  if (IS_APP) return null;

  const { version } = props;

  // Version 1 will keep the old color rgb(127, 42, 0) on subscribe button
  if (
    version == 1 // version is string, use type conversion
    || !version // default case is 1, because options are [1,2,3,...], the first one would be shown in editor options
  ) {
    return <OldFooterWrapper><FFFooter {...props} /></OldFooterWrapper>;
  } else if (version == 2) {
    return <FFFooter {...props} />
  } else if (version == 3) {
    return <FFFooter2 {...props} />
  } else if (version == 4) {
    return <FFFooter3 {...props} regions={props.regionsV4} />
  }
}
